import { Icons } from "components";
import { RankDisplayStyled } from "./styled";

const RankDisplay = ({ rank }) => {
  return (
    <RankDisplayStyled>
      {rank === 1 && <Icons.RankNo1 />}
      {rank === 2 && <Icons.RankNo2 />}
      {rank === 3 && <Icons.RankNo3 />}
      {rank > 3 && <span className="rank_plain">{rank}</span>}
    </RankDisplayStyled>
  );
};

export default RankDisplay;
